// extracted by mini-css-extract-plugin
module.exports = {"jobSearchDetail-salary__detail":"jobSearchDetail-salary__detail","jobSearchDetail-salary__items":"jobSearchDetail-salary__items"};